export const AccountProvenance = {
  InitialSeed: -2,
  OpenBankingSandbox: -1,
  OpenBanking: 0,
  BankStatement: 1,
  Manual: 2,
} as const
export type AccountProvenance = (typeof AccountProvenance)[keyof typeof AccountProvenance]

export const OpenBankingStatus = {
  Error: -1,
  Pending: 0,
  Success: 1,
  Retry: 2,
} as const
export type OpenBankingStatus = (typeof OpenBankingStatus)[keyof typeof OpenBankingStatus]

export interface BankAccount {
  id: number
  accountName?: string
  currencyIsoCode?: string
  currencyId?: number
  description?: string
  bic?: string
  accountNumber?: string
  iban?: string
  ownerName?: string
  institutionName?: string
  // Country of the assigned institution, as reported by the backend (never inferred
  // by the SPA). Null/absent for global institutions or accounts without one.
  institutionCountryCode?: string | null
  institutionCountryName?: string | null
  companyName?: string
  companyGroupName?: string
  companyId: number
  createdOn?: string
  createdByEmail?: string
  closingBalance?: number
  closingBalanceDate?: string
  availableBalance?: number | null
  openBankingAccessExpiryDate?: string
  openBankingDaysUntilExpiry?: number
  openBankingStatusName?: string
  lastTransactionDate?: string
  lastBankUpdate?: string
  balanceFromUserExists?: boolean
  isMultiCurrency?: boolean
  hasParent?: boolean
  accountProvenance?: AccountProvenance
  openBankingStatus?: OpenBankingStatus
  connectivity?: string
  /** Whether the backend allows changing the connection from the edit wizard (th_saas CU-93). */
  connectivityEditable?: boolean
  format?: string
  active: boolean
  canReconnect: boolean
  connectionStatus: string
  /** Whether payments may be created, saved or dispatched from this account at all. */
  paymentsEnabled?: boolean
  /** Which dispersion channel it pays by. Null — the usual case — means it disperses nothing. */
  paymentRuleId?: number | null
  /** That rule's label, for the grid's badge. Null whenever paymentRuleId is. */
  dispersesThrough?: string | null
}

export interface FilterOption {
  Id: number | string
  Label: string
}

export interface BankAccountFilterValues {
  institutions: FilterOption[]
  currencies: FilterOption[]
  companies: FilterOption[]
  companyGroups: FilterOption[]
  connectivity: FilterOption[]
  isActive: FilterOption[]
}

export interface SetBalanceRequest {
  accountId: number
  valueDate: string
  balanceValue: number
}
